/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyRefDto } from './companyRefDto';
import { UpdateUserProfileDto } from './updateUserProfileDto';


export interface UpdateUserDto { 
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    /**
     * can be used as an alternative for email to login. If empty, email will be set.
     */
    username?: string;
    agency?: CompanyRefDto;
    status?: string;
    profile?: UpdateUserProfileDto;
    sso?: boolean;
    salutation?: string;
    companyInfo?: string;
    expiryDate?: string;
    groups?: Array<string>;
    externalFlag?: boolean;
    failedLoginAttempts?: number;
}

